import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { AlertService } from 'src/app/services/alert/alert.service';
import * as fromAccounts from '../../actions/accounts/accounts.actions';
import * as fromCards from '../../actions/cards/cards.actions';

@Injectable()
export class AlertEffects {
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private actions$: Actions, private alertService: AlertService) {}

  // Account Effect
  unableToLoadAccountDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccounts.loadAccountDetailsFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );

  unableToLoadAccountTransactions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccounts.loadTransactionHistoryFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );

  unableToLoadAccountUnsignedOrders$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccounts.loadUnsignedOrdersFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );

  unableToLoadStatement$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccounts.loadAccountStatementsFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );

  // Template Effect
  unableToLoadTemplate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccounts.loadAccountStatementsFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );

  // Cards Effect
  unableToLoadCardTransactions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromCards.loadTransactionHistoryFailure),
        tap(res => {
          this.alertService.error(res.error, this.options);
        })
      ),
    { dispatch: false }
  );
}
